var map = {
	"./platform_1.png": "949a",
	"./platform_10.png": "4796",
	"./platform_11.png": "d52c",
	"./platform_12.png": "1d0f",
	"./platform_13.png": "0bb5",
	"./platform_14.png": "a575",
	"./platform_2.png": "2717",
	"./platform_3.png": "f395",
	"./platform_4.png": "7bb6",
	"./platform_5.png": "fb85",
	"./platform_6.png": "7057",
	"./platform_7.png": "b4672",
	"./platform_8.png": "8230",
	"./platform_9.png": "b415"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15c9";